export default __webpack_public_path__ + "static/kompetensi-50f7f441c1563556ef1e8dac86dd6b42.jpg";